import React, { useState } from 'react'
import FormField from '../../atoms/FormField/FormField'
import FormInput from '../../atoms/FormInput/FormInput'
import FormSelect from '../../atoms/FormSelect/FormSelect'
import Button from '../../atoms/Button/Button'
import validationSchemaRichiestaAttivazione from './validationSchema'
import { api } from '../../../utils/index'
import { RICHIESTAATTIVAZIONE } from '../../../utils/endpoint'
import { useRouter } from 'next/router'
import { Formik } from 'formik'
import useTrans from '../../../hooks/useTrans'
import { Breadcrumbs, MetaSeo, Trans } from '../../../components/index'
import usePrivacy from '../../../hooks/usePrivacy'
import { useSelector } from 'react-redux'

const FormRichiestaAttivazione = ({ page }) => {
  const t = useTrans()
  const router = useRouter()
  const initialValues = {
    azienda: '',
    nome: '',
    email: '',
    telefono: '',
    tipologia: true,
  }
  const [params, setEntrys] = useState(initialValues)
  const [selectedTipologia, setSelectedTipologia] = useState()
  const { getUrlInformativaFromStore } = usePrivacy()
  const { service_gift } = useSelector((state) => state.servicegift)
  const { azienda, nome, email, telefono, tipologia } = params
  params.tipologia = selectedTipologia
  const handleChange = (e) => {
    setEntrys({ ...params, [e.target.name]: e.target.value })
  }
  const _postPayload = async (values) => {
    await api.post(RICHIESTAATTIVAZIONE, params).then((res) => {
      if (res) {
        router.push(`/richiesta-attivazione/success`)
      }
    })
  }
  return (
    <div className="page richiesta-attivazione">
      <MetaSeo seo={page.seo} />
      <div className="w-container">
        <Breadcrumbs breadcrumbs={page.breadcrumbs} />
        <h2 className="page__title">
          <Trans chiave="Richiesta Attivazione" />
        </h2>
        <p className="richiesta-attivazione__description">
          {t(
            'Compila tutti i campi per inviare la richiesta di attivazione al servizio Service Gift'
          )}
        </p>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchemaRichiestaAttivazione}
        >
          {({ errors, touched, props }) => (
            <div className="richiesta-attivazione__form">
              <div className="richiesta-attivazione__fields">
                <div className="richiesta-attivazione__field">
                  <FormField
                    label={t('Azienda')}
                    status={
                      touched.azienda && errors.azienda ? 'error' : touched.azienda && 'success'
                    }
                    errorMessage={errors?.azienda}
                  >
                    <FormInput name="azienda" value={azienda} onChange={handleChange} />
                  </FormField>
                </div>
                <div className="richiesta-attivazione__field">
                  <FormField
                    label={t('Nome')}
                    status={touched.nome && errors.nome ? 'error' : touched.nome && 'success'}
                    errorMessage={errors?.nome}
                  >
                    <FormInput name="nome" value={nome} onChange={handleChange} />
                  </FormField>
                </div>
                <div className="richiesta-attivazione__field">
                  <FormField
                    label={t('E-mail')}
                    status={touched.email && errors.email ? 'error' : touched.email && 'success'}
                    errorMessage={errors?.email}
                  >
                    <FormInput name="email" type="email" value={email} onChange={handleChange} />
                  </FormField>
                </div>
                <div className="richiesta-attivazione__field">
                  <FormField
                    label={t('Telefono')}
                    status={
                      touched.telefono && errors.telefono ? 'error' : touched.telefono && 'success'
                    }
                    errorMessage={errors?.telefono}
                  >
                    <FormInput name="telefono" value={telefono} onChange={handleChange} />
                  </FormField>
                </div>
                <div className="richiesta-attivazione__field">
                  <FormField
                    label={t('Tipologia')}
                    status={
                      touched.tipologia && errors.tipologia
                        ? 'error'
                        : touched.tipologia && 'success'
                    }
                    errorMessage={errors?.tipologia}
                  >
                    <FormSelect
                      placeholder={t("Seleziona tipologia")}
                      options={[
                        {
                          label: t('Service Gift Sito E-commerce'),
                          value: true,
                        },
                        {
                          label: t('Service Gift Sito vetrina'),
                          value: false,
                        },
                      ]}
                      onChange={(e) => {
                        setSelectedTipologia(e.target.value)
                      }}
                    ></FormSelect>
                  </FormField>
                </div>
              </div>
              {!service_gift?.attivo && (
                <p style={{ fontSize: 14 }}>
                  {t('Contattandoci, dichiari di aver letto e compreso')}{' '}
                  <a
                    target="_blank"
                    style={{ textDecoration: 'underline', fontWeight: 'bold' }}
                    href={getUrlInformativaFromStore()}
                  >
                    {t("l'Informativa Privacy")}
                  </a>
                </p>
              )}
              <Button
                label="Richiedi attivazione"
                variant="primary"
                size="medium"
                type="submit"
                onClick={_postPayload}
                className="richiesta-attivazione__submit"
              />
            </div>
          )}
        </Formik>
      </div>
    </div>
  )
}

export default FormRichiestaAttivazione
